import React from "react";
import { ProjectNotificationModel } from "../../../models/ProjectNotificationModel";
import { displayDateFormart } from "../../../utility/utils";

type Props = {
  data: ProjectNotificationModel;
};

const NotificationItem = ({ data }: Props) => {
  return (
    <div className="notification-wrapper">
      <div className="d-flex justify-content-between">
        <div className="fw-bold text-capitalize">{data.projectName}</div>
        <div className="text-muted">
          {displayDateFormart(data.creationDate)}
        </div>
      </div>
      <div className="small pt-2">{data.notificationMessage}</div>
    </div>
  );
};

export default NotificationItem;
